/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import MonitoringControllerDtoGearNftListRequest from '../model/MonitoringControllerDtoGearNftListRequest';
import MonitoringControllerDtoGearNftListResponse from '../model/MonitoringControllerDtoGearNftListResponse';
import MonitoringControllerDtoNftBoxListRequest from '../model/MonitoringControllerDtoNftBoxListRequest';
import MonitoringControllerDtoNftBoxListResponse from '../model/MonitoringControllerDtoNftBoxListResponse';
import MonitoringControllerDtoNftCarListRequest from '../model/MonitoringControllerDtoNftCarListRequest';
import MonitoringControllerDtoNftCarListResponse from '../model/MonitoringControllerDtoNftCarListResponse';
import MonitoringControllerDtoPilotNftListRequest from '../model/MonitoringControllerDtoPilotNftListRequest';
import MonitoringControllerDtoPilotNftListResponse from '../model/MonitoringControllerDtoPilotNftListResponse';
import MonitoringControllerDtoWalletListRequest from '../model/MonitoringControllerDtoWalletListRequest';
import MonitoringControllerDtoWalletListResponse from '../model/MonitoringControllerDtoWalletListResponse';

/**
* PerplayMonitoring service.
* @module api/PerplayMonitoringApi
* @version 1.0
*/
export default class PerplayMonitoringApi {

    /**
    * Constructs a new PerplayMonitoringApi. 
    * @alias module:api/PerplayMonitoringApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the apiPerplayMonitoringGearNftListPost operation.
     * @callback module:api/PerplayMonitoringApi~apiPerplayMonitoringGearNftListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MonitoringControllerDtoGearNftListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MonitoringControllerDtoGearNftListRequest} [monitoringControllerDtoGearNftListRequest] 
     * @param {module:api/PerplayMonitoringApi~apiPerplayMonitoringGearNftListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MonitoringControllerDtoGearNftListResponse}
     */
    apiPerplayMonitoringGearNftListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['monitoringControllerDtoGearNftListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = MonitoringControllerDtoGearNftListResponse;
      return this.apiClient.callApi(
        '/api/PerplayMonitoring/GearNftList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayMonitoringNftBoxListPost operation.
     * @callback module:api/PerplayMonitoringApi~apiPerplayMonitoringNftBoxListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MonitoringControllerDtoNftBoxListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MonitoringControllerDtoNftBoxListRequest} [monitoringControllerDtoNftBoxListRequest] 
     * @param {module:api/PerplayMonitoringApi~apiPerplayMonitoringNftBoxListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MonitoringControllerDtoNftBoxListResponse}
     */
    apiPerplayMonitoringNftBoxListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['monitoringControllerDtoNftBoxListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = MonitoringControllerDtoNftBoxListResponse;
      return this.apiClient.callApi(
        '/api/PerplayMonitoring/NftBoxList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayMonitoringNftCarListPost operation.
     * @callback module:api/PerplayMonitoringApi~apiPerplayMonitoringNftCarListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MonitoringControllerDtoNftCarListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MonitoringControllerDtoNftCarListRequest} [monitoringControllerDtoNftCarListRequest] 
     * @param {module:api/PerplayMonitoringApi~apiPerplayMonitoringNftCarListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MonitoringControllerDtoNftCarListResponse}
     */
    apiPerplayMonitoringNftCarListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['monitoringControllerDtoNftCarListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = MonitoringControllerDtoNftCarListResponse;
      return this.apiClient.callApi(
        '/api/PerplayMonitoring/NftCarList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayMonitoringPilotNftListPost operation.
     * @callback module:api/PerplayMonitoringApi~apiPerplayMonitoringPilotNftListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MonitoringControllerDtoPilotNftListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MonitoringControllerDtoPilotNftListRequest} [monitoringControllerDtoPilotNftListRequest] 
     * @param {module:api/PerplayMonitoringApi~apiPerplayMonitoringPilotNftListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MonitoringControllerDtoPilotNftListResponse}
     */
    apiPerplayMonitoringPilotNftListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['monitoringControllerDtoPilotNftListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = MonitoringControllerDtoPilotNftListResponse;
      return this.apiClient.callApi(
        '/api/PerplayMonitoring/PilotNftList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayMonitoringWalletListPost operation.
     * @callback module:api/PerplayMonitoringApi~apiPerplayMonitoringWalletListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MonitoringControllerDtoWalletListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MonitoringControllerDtoWalletListRequest} [monitoringControllerDtoWalletListRequest] 
     * @param {module:api/PerplayMonitoringApi~apiPerplayMonitoringWalletListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MonitoringControllerDtoWalletListResponse}
     */
    apiPerplayMonitoringWalletListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['monitoringControllerDtoWalletListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = MonitoringControllerDtoWalletListResponse;
      return this.apiClient.callApi(
        '/api/PerplayMonitoring/WalletList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
